import { Link } from "react-router-dom";

const products = [
  {
    name: "Social Housing\nStructured Product",
    badge: "Flagship",
    return: "10.00%",
    term: "5 Years",
    frequency: "Monthly",
    minInvest: "£10,000",
    security: "First Legal Charge",
    currency: "GBP",
    status: "Open",
    link: "/social-housing",
  },
  {
    name: "UK Commercial\nProperty Income Fund",
    badge: "Conservative",
    return: "7.00%",
    term: "5 Years",
    frequency: "Semi-Annual",
    minInvest: "£50,000",
    security: "Senior Secured",
    currency: "GBP",
    status: "Open",
    link: "/contact",
  },
];

const rows = [
  { label: "Target Return p.a.", key: "return", highlight: true },
  { label: "Investment Term", key: "term" },
  { label: "Distribution", key: "frequency" },
  { label: "Min. Investment", key: "minInvest" },
  { label: "Security", key: "security" },
  { label: "Currency", key: "currency" },
  { label: "Status", key: "status" },
];

export default function CompareProductsTable() {
  return (
    <div className="mt-12 mb-2">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-table-2 text-[#C9A84C] text-base leading-none" />
        </div>
        <h3
          className="text-white font-bold text-lg"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          UK Structured Products — Side by Side
        </h3>
        <span className="text-slate-500 text-xs">UK products compared</span>
      </div>

      <div className="overflow-x-auto rounded-2xl border border-white/10">
        <table className="w-full min-w-[700px] border-collapse">
          <thead>
            <tr style={{ background: "rgba(201,168,76,0.10)" }}>
              <th className="text-left px-5 py-4 text-xs font-semibold text-slate-400 uppercase tracking-widest w-36 border-r border-white/8">
                Metric
              </th>
              {products.map((p) => (
                <th key={p.name} className="px-5 py-4 text-center border-r last:border-r-0 border-white/8">
                  <span className="inline-block text-[9px] font-bold uppercase tracking-widest text-[#C9A84C] bg-[#C9A84C]/15 border border-[#C9A84C]/25 px-2 py-0.5 rounded-full mb-2">
                    {p.badge}
                  </span>
                  <p
                    className="text-white font-bold text-sm leading-snug whitespace-pre-line"
                    style={{ fontFamily: "'Playfair Display', serif" }}
                  >
                    {p.name}
                  </p>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, ri) => (
              <tr
                key={row.key}
                className={ri % 2 === 0 ? "bg-white/3" : "bg-transparent"}
              >
                <td className="px-5 py-3.5 text-xs text-slate-400 font-medium border-r border-white/8 whitespace-nowrap">
                  {row.label}
                </td>
                {products.map((p) => {
                  const val = p[row.key as keyof typeof p];
                  return (
                    <td key={p.name} className="px-5 py-3.5 text-center border-r last:border-r-0 border-white/8">
                      {row.key === "status" ? (
                        <span className="inline-flex items-center gap-1 text-xs font-semibold text-green-400 bg-green-500/10 px-2.5 py-1 rounded-full">
                          <span className="w-1.5 h-1.5 rounded-full bg-green-400 inline-block" />
                          {val}
                        </span>
                      ) : row.highlight ? (
                        <span
                          className="text-[#C9A84C] font-bold text-base"
                          style={{ fontFamily: "'Playfair Display', serif" }}
                        >
                          {val}
                        </span>
                      ) : (
                        <span className="text-white text-xs font-semibold">{val}</span>
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
            {/* CTA row */}
            <tr className="bg-white/5">
              <td className="px-5 py-4 text-xs text-slate-400 font-medium border-r border-white/8">
                Details
              </td>
              {products.map((p) => (
                <td key={p.name} className="px-5 py-4 text-center border-r last:border-r-0 border-white/8">
                  <Link
                    to={p.link}
                    className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg text-xs font-semibold transition-all cursor-pointer whitespace-nowrap"
                    style={{ background: "rgba(201,168,76,0.18)", color: "#C9A84C" }}
                  >
                    View Product
                    <i className="ri-arrow-right-line leading-none text-xs" />
                  </Link>
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>

      <p className="text-slate-600 text-xs mt-4 text-center">
        Returns are targets only. Capital at risk. Past performance is not indicative of future results.
      </p>
    </div>
  );
}
